import { CompanyState } from "@/store/interfaces/company";

export const state: CompanyState = {
  wizard: {
    status: false,
    didInvalidate: false,
    companyId: "",
    companyName: "",
    companyUrl: "",
    receivedAt: 0,
    connectionError: false
  },
  company: {
    status: false,
    didInvalidate: false,
    companyId: "",
    companyName: "",
    companyUrl: "",
    receivedAt: 0,
    connectionError: false
  }
};
